const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUserAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1733.3333 1733.3333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1733.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13000,0 H 0 V 13000 H 13000 V 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9127.25,6842.19 c 0,-2036.98 -1169.67,-3688.29 -2612.53,-3688.29 -1442.86,0 -2612.53,1651.31 -2612.53,3688.29 0,2036.98 1169.67,3688.31 2612.53,3688.31 1442.86,0 2612.53,-1651.33 2612.53,-3688.31",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8145.88,4171.2 H 4883.56 c 0,0 453.1,-1760 -362.48,-2585 h 1993.64 1993.64 c -815.58,825 -362.48,2585 -362.48,2585",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3928.34,6840.72 c 0,0 -1193.55,2897.29 113.41,3100.02 l 221.59,-164.98 c 0,0 926.39,-810.83 -335,-2935.04",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9095.5,6840.72 c 0,0 1193.5,2897.29 -113.41,3100.02 L 8760.5,9775.76 c 0,0 -926.39,-810.83 335,-2935.04",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4041.75,9933.66 c 0,0 1815.41,2104.04 4692.13,586.84 0,0 1898.32,-3104.21 -4133.97,-1653.98 l -558.16,1067.14",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4390.14,6119.68 c 100.68,-480.86 19.64,-904.74 -181.02,-946.75 -200.65,-42.01 -444.93,313.75 -545.61,794.61 -100.68,480.87 -19.63,904.74 181.02,946.76 200.65,42.01 444.93,-313.75 545.61,-794.62",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8653.82,6119.68 c -100.68,-480.86 -19.64,-904.74 181.02,-946.75 200.65,-42.01 444.93,313.75 545.61,794.61 100.68,480.87 19.64,904.74 -181.02,946.76 -200.65,42.01 -444.93,-313.75 -545.61,-794.62",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8508.36,10436.9 c 0,0 755.03,187.3 1012.6,562 0,0 46.83,-444.9 -679.04,-843 l -333.56,281",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8508.36,10083.3 c 0,0 755.03,187.3 1012.6,562 0,0 46.83,-444.9 -679.04,-842.99 l -333.56,280.99",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6.73438,0 c 0,0 378.38662,968.902 1252.95562,1163.1 874.58,194.1 5240.31,1163 5240.31,1163 0,0 4445,-981.8 5243,-1163 C 12541,981.801 12993.3,0 12993.3,0 H 6.73438",
    style: {
      fill: "#7a7e82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserAvatar);
export default __webpack_public_path__ + "static/media/default-user-avatar.9114287e04bd73c021a1fff9eba16efb.svg";
export { ForwardRef as ReactComponent };